export default __webpack_public_path__ + "static/media/sticker-V.8dea7fca.png";